import { default as Button } from "./button";

export default class ButtonGroup extends Button {
	static get observable() {
		return [...super.observable, "hidden-name", "size", "spacing", "variation", "label", "helper-text", "type"];
	}

	constructor() {
		super();

    this.selectedIndex = 0;

    if (this.type !== "multi") { this.type = "single"; }
		if (this.closest("form") && !this.hiddenName) { this.hiddenName = this.id; }
	}

	parsedCallback() {
		const wrapper = document.createElementWithContents("div", document.createElementWithContents("ul", [...this.children ?? []].map(x => document.createElementWithContents("li", x))), { className: "button-group__container" });

		const buttons = wrapper.querySelectorAll("chip-button, chip-dropdownbutton, chip-splitbutton");

		if (buttons.length < 6) {
			wrapper.querySelector("ul").setAttribute("columns", buttons.length);
		}

		buttons.forEach(button => {
			this.addButton(button);
		});

		if (this.hiddenName) {
			wrapper.appendChild(document.createElementWithContents("input", null, {
				type: "hidden",
				value: this.value,
				name: this.hiddenName
			}));
		}

		if (this.label) {
			wrapper.prepend(document.createElementWithContents("div", this.label, { className: "input-field__label" }));
		}

		this.appendChild(wrapper);

		if (this.helperText) {
			wrapper.appendChild(document.createElementWithContents("div", this.helperText, { className: "input-field__helper-text" }));
		}

		this.#SelectValue(this.value);
	}

	addButton(button) {
		const list = this.querySelector(".button-group__container>ul");

		if (list?.contains(button) === false) {
			list.appendChild(document.createElementWithContents("li", button));
		}

		if (!button.getAttribute("size") && this.size) { button.size = this.size; }
		if (!button.getAttribute("buttonStyle") && this.buttonStyle) { button.buttonStyle = this.buttonStyle; }
		if (!button.getAttribute("orientation") && this.orientation) { button.orientation = this.orientation; }

		if (this.variation) { button.variation = this.variation; }
		if (this.disabled) { button.disabled = this.disabled; }

		const buttonClass = [button.buttonClass, this.buttonClass].map(x => x?.trim()).filter(Boolean).join(" ");

		if (buttonClass) { button.buttonClass = buttonClass; }

		switch (button.nodeName) {
			case "CHIP-BUTTON":
				button.addEventListener("click", ev => this.#HandleButtonClick(ev.target));
				break;
			case "CHIP-DROPDOWNBUTTON":
				button.querySelector("chip-dropdown").onselectionchange = () => this.#HandleButtonClick(button);
				break;
			case "CHIP-SPLITBUTTON":
				button.addEventListener("click", ev => this.#HandleButtonClick(ev.target));
				button.querySelectorAll("chip-dropdownitem").forEach(item => item.addEventListener("click", ev => this.#HandleButtonClick(ev.target)));
				break;
		}
	}

	#SelectButton(button) {
		if (!button) { return; }

		if (this.type === "single") {
			this.querySelectorAll("chip-button, chip-dropdownbutton, chip-splitbutton").forEach(btn => {
				btn.active = btn === button;
			});
		} else {
			button.active = true;
		}

		this.selectedItem = button;
		this.#UpdateHiddenInput();
	}

  #GetButtons() {
    return [...this.querySelectorAll("chip-button[value], chip-splitbutton[value], chip-dropdownbutton[value]")];
  }

	#SelectValue(value) {
    this.#GetButtons().forEach((button, ix) => {
      if (value?.split("|").includes(button.value?.toString())) {
        this.#SelectButton(button);
        this.selectedIndex = ix;
      }
    });
	}

	#UpdateHiddenInput() {
		const hiddenInput = this.querySelector("input[type='hidden']");

		if (hiddenInput) {
			hiddenInput.value = [...this.querySelectorAll("chip-button[active], chip-dropdownbutton[active], chip-splitbutton[active]")].
				map(x => x.value).join("|");
		}
	}

	#HandleButtonClick(target) {
		const closestButton = target.closest("chip-button, chip-splitbutton, chip-dropdownbutton");

		let elements = (this.type === "single" ? [] : [...this.querySelectorAll("chip-button[active], chip-dropdownbutton[active], chip-splitbutton[active]")]).concat(closestButton);

		if (closestButton.active && this.type !== "single") {
			elements = elements.filter(x => x !== closestButton);

			closestButton.active = false;
			this.#UpdateHiddenInput();
		}

		const oldValue = this.value;
		this.value = elements.map(x => x.value).join("|");

    this.selectedIndex = Math.max(0, [...this.querySelectorAll("chip-button[value], chip-splitbutton[value], chip-dropdownbutton[value]")].indexOf(closestButton));

		if (oldValue !== this.value) {
			this.raiseEvent("change");
		}
	}

	removeValue(value) {
		for (const target of [...this.querySelectorAll("chip-button, chip-splitbutton, chip-dropdownbutton")].filter(x => value?.toString().split("|").includes(x.value?.toString()))) {
			target.remove();
		}
	}

	attributeChanged(name, _, newValue) {
		if (name === "value") {
			this.#SelectValue(newValue);
		}
	}
}
